import api from '../config';
import URLS from '../../constants/urls';
export const _getConnectionsBySiteID = async (siteId, pageNumber, pageSize) => {
    const response = await api.get(`${URLS.CONNECTION}/${siteId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
export const _createConnection = async (data) => {
    const response = await api.post(`${URLS.CONNECTION}/create`, data);
    return response.data;
};
export const _deleteConnection = async (siteId, connectionId) => {
    const response = await api.delete(`${URLS.CONNECTION}/${siteId}/${connectionId}`);
    return response.data;
};
